import { ca } from '@cian/analytics';

interface ITrackSendMessageClickParams {
  label: string;
  placeType: string;
  sellerType?: 'builders' | 'agents';
}

export function trackSendMessageClick({ label, placeType, sellerType }: ITrackSendMessageClickParams) {
  ca('eventSite', {
    action: 'send_message',
    category: 'CardJK',
    label,
    name: 'oldevent',
    useLastProducts: true,
    page: {
      extra: {
        type: placeType,
        seller_type: sellerType,
      },
    },
  });
}
